import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { get, post } from "../../utils/fetch";
import { Organization } from "../organizations/types";
import { FamilyMemberSms, Page, RootState } from "../types";
import history from "../../history";

import SelectFamilyMembers from "./components/SelectFamilyMembers";
import { Patient } from "../patient/types";

const FamilyCommunicationsPage = (props: any) => {
  const { patientId } = props.match.params;

  const [familyMembers, setFamilyMembers] = useState<Page<FamilyMemberSms> | null>(null);
  const [patient, setPatient] = useState<Patient>(null);
  const currentOrg: Organization | null = useSelector(
    (state: RootState) => state.orgs.currentOrganization
  );

  const getPatient = async () => {
    const url = `/api/organization/${currentOrg?.id}/patients/${patientId}/`;
    const resp = await get<Patient>(url);

    if (resp.data) {
      setPatient(resp.data);
    }
  };

  const getFamilyMembers = async () => {
    const url = `/api/organization/${currentOrg?.id}/patients/${patientId}/familyMembers/`;
    const resp = await get<Page<FamilyMemberSms>>(url);

    if (resp.data) {
      setFamilyMembers(resp.data);
    }
  };

  useEffect(() => {
    getPatient();
    getFamilyMembers();
  }, []);

  const startVideoChatSms = async () => {
    const url = `/api/organization/${currentOrg?.id}/patients/${patientId}/secureFamilyVideoConference/`;
    const body = {
      familyMemberIds: familyMembers?.results.filter(x => x.ischecked).map(y => y.id),
      includePatient: false
    };
    const resp = await post<{ providerUid: string }>(url, body);

    if (resp.data) {
      history.push(`/video_chat/${resp.data.providerUid}`);
    }
  };

  return (
    <div className="message-container sections">
      {familyMembers && (
        <div className="section p-15">
          <h1>Family Updates - Video Visit</h1>
          <div className="title mb-20">
            Patient: {patient?.givenName} {patient?.familyName}
          </div>
          <SelectFamilyMembers
            patientId={patientId}
            familyMembers={familyMembers}
            setFamilyMembers={setFamilyMembers}
            allowMany={false}
          />
          <div className="flex-end mt-10">
            <button
              className="mt-10 video-invite"
              onClick={startVideoChatSms}
              disabled={
                !familyMembers?.results.some(x => x.ischecked) ||
                currentOrg?.smsCommunicationDisabled
              }
            >
              <i className="fas fa-video mr-5"></i> Text Video Visit Invite
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FamilyCommunicationsPage;
